import React, { useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import FormInput from '../../../../commonComponents/forms/FormInput';

function FormNewRecommendation({ t, recommendation }) {
  const [state, setState] = useState(recommendation);
  const handleChange = field => value =>
    setState(prevState => ({ ...prevState, [field]: value }));
  return (
    <div style={{ padding: '2rem' }}>
      <FormInput
        id="firstName"
        value={state.firstName}
        name="firstName"
        label={t('sessionDetails_modal.firstName')}
        labelClassName="col-lg-1"
        containerClassName="col-lg-11"
        disabled={false}
        type="text"
        onChange={handleChange('firstName')}
        groupProps={{ className: 'row' }}
      />
      <FormInput
        id="lastName"
        value={state.lastName}
        name="lastName"
        label={t('sessionDetails_modal.lastName')}
        labelClassName="col-lg-1"
        containerClassName="col-lg-11"
        disabled={false}
        type="text"
        onChange={handleChange('lastName')}
        groupProps={{ className: 'row' }}
      />
      <FormInput
        id="email"
        value={state.email}
        name="email"
        label={t('sessionDetails_modal.email')}
        labelClassName="col-lg-1"
        containerClassName="col-lg-11"
        disabled={false}
        type="text"
        onChange={handleChange('email')}
        groupProps={{ className: 'row' }}
      />
    </div>
  );
}
FormNewRecommendation.propTypes = {
  t: PropTypes.func.isRequired,
  recommendation: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
};

FormNewRecommendation.defaultProps = {
  recommendation: {
    firstName: '',
    lastName: '',
    email: '',
  },
};

export default translate(FormNewRecommendation);
